import { writable } from 'svelte/store'
import { getBreakpoint } from 'helpers/css'

export default writable(
  document.documentElement.clientWidth < getBreakpoint('md')
)
